import React from 'react';
import { Catalog } from './components/Catalog';
import { InventoryProvider } from './contexts/InventoryContext';
export function App() {
  return <InventoryProvider data-id="element-0" data-mp="35eemmx2prmbg">
      <Catalog data-id="element-1" data-mp="3k9krhgq2pf37" />
    </InventoryProvider>;
}